export default "__VITE_ASSET__DCPyAsVX__"